import '@sagi.io/globalthis';
import { Capacitor } from '@capacitor/core';

export default class Device {
	constructor() {
		this.onBackButton = null;
		document.addEventListener('deviceready', () => this.onDeviceReady(), false);
	}

	onDeviceReady() {
		document.addEventListener('backbutton', (e) => this.backButton(e), false);

		globalThis.AndroidFullScreen?.immersiveMode?.();
	}

	backButton(e) {
		if (typeof this.onBackButton === 'function') {
			e.preventDefault();
			this.onBackButton();
		}
	}

	exitApp() {
		if (typeof navigator.app?.exitApp === 'function') {
			navigator.app.exitApp();
		} else if (typeof navigator.device?.exitApp === 'function') {
			navigator.device.exitApp();
		} else {
			window.close();
		}
	}

	/**
	 * @returns {OSType}
	 */
	getOS() {
		const ua = navigator.userAgent;

		if (/(MSAppHost\/3.0)/i.test(navigator.appVersion)) {
			// Windows 10 UWP
			return 'windows';
		}

		const isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFSAW|KFSOWI|KFTBW|KFTHW|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(ua);
		if (/(android)/i.test(navigator.userAgent) && isKindle) {
			return 'amazon';
		}

		if (/(android)/i.test(navigator.userAgent) && !isKindle) {
			return 'android';
		}

		if (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel') {
			return 'ios';
		}

		if (/(win)/i.test(navigator.userAgent)) {
			return 'windows';
		}

		return 'web';
	}

	/** @typedef {'FBMessenger' | 'windowsPhone' | 'windows' | 'amazon' | 'android' | 'ios' | 'Steam' | 'windowsPWA' | 'web'} OSType */

	getBrowser() {
		return navigator.userAgent;
	}

	/**
	 * @returns {PlatformType}
	 */
	getPlatform() {
		//facebook instant
		if (typeof globalThis.FBInstant !== 'undefined') {
			return 'FBInstant';
		}

		//native Cordova
		if (typeof globalThis.cordova !== 'undefined') {
			const isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFSAW|KFSOWI|KFTBW|KFTHW|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(navigator.userAgent);
			if (/(android)/i.test(navigator.userAgent) && isKindle) {
				return 'amazon';
			}

			if (/(android)/i.test(navigator.userAgent) && !isKindle) {
				return 'android';
			}

			if (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel') {
				return 'ios';
			}
		}

		//native Capacitor
		if (Capacitor.isNativePlatform() === true) {
			if (Capacitor.getPlatform() === 'ios') {
				return 'ios';
			}

			if (Capacitor.getPlatform() === 'android') {
				return 'android';
			}

			return Capacitor.getPlatform();
		}

		//stream
		const searchParams = new URLSearchParams(window.location.search);
		if (searchParams.get('steamId')) {
			return 'steam';
		}

		//pwa + edg = Edge
		const isInStandaloneMode = (window.matchMedia('(display-mode: standalone)').matches) || (globalThis.navigator.standalone) || document.referrer.includes('android-app://');
		if (isInStandaloneMode && /(Edg)/i.test(navigator.userAgent)) {
			return 'windowsPWA';
		}

		return 'web';
	}

	/** @typedef {'FBInstant' | 'windowsPhone' | 'windows' | 'amazon' | 'android' | 'ios' | 'steam' | 'windowsPWA' | 'web'} PlatformType */

}
